
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/vip-consultation",
      function () {
        return require("private-next-pages/vip-consultation/index.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/vip-consultation"])
      });
    }
  